import { defineComponent } from "vue";
import { COMPONENT_NAME } from "./attributes";
import { SharedSelect } from "@/components/shared";
import { ApplicationStoreRequest } from "@/shared/repository/modules/application/repo";
import { SelectOptionFactory } from "@/shared/factory/select";
import { SharedSelectOption } from "@/components/shared/select/model";

export default defineComponent({
  name: COMPONENT_NAME,
  components: {
    SharedSelect,
  },
  props: {
    buyRate: {
      type: Number,
      default: 0,
    },
    sellRate: {
      type: Number,
      default: 0,
    },
  },
  emits: ["pair-changed"],
  data() {
    return {
      buyCurrencySelected: {
        value: 19,
      },
      sellCurrencySelected: {
        value: 18,
      },
      applicationRepo: this.$projectServices.applicationRepo,
      walletRepo: this.$projectServices.walletRepo,
    };
  },
  mounted() {
    this.emitPairChange();
  },
  watch: {
    "buyCurrencySelected.value"() {
      this.emitPairChange();
    },
    "sellCurrencySelected.value"() {
      this.emitPairChange();
    },
  },
  computed: {
    displayedApplicationStoreRequest(): ApplicationStoreRequest {
      return this.applicationRepo.application;
    },
    buyCurrencyOptions(): SharedSelectOption[] {
      return this.walletRepo.list.map((currency) =>
        SelectOptionFactory(
          {
            id: currency.id,
            label: currency.name,
            value: currency.id,
            icon: currency.type === "crypto" ? currency.name : currency.country,
            type: currency.type,
          },
          this.buyCurrencySelected.value
        )
      );
    },
    sellCurrencyOptions(): SharedSelectOption[] {
      return this.walletRepo.list.map((currency) =>
        SelectOptionFactory(
          {
            id: currency.id,
            label: currency.name,
            value: currency.id,
            icon: currency.type === "crypto" ? currency.name : currency.country,
            type: currency.type,
          },
          this.sellCurrencySelected.value
        )
      );
    },
    buyCurrencyIcon(): string {
      const currency = this.walletRepo.list.find(
        (c) => c.id === this.buyCurrencySelected.value
      );
      return currency
        ? currency.type === "crypto"
          ? currency.name
          : currency.country
        : "";
    },
    sellCurrencyIcon(): string {
      const currency = this.walletRepo.list.find(
        (c) => c.id === this.sellCurrencySelected.value
      );
      return currency
        ? currency.type === "crypto"
          ? currency.name
          : currency.country
        : "";
    },
    isUsdUsdtPair(): boolean {
      const buyCurrency = this.walletRepo.list.find(
        (c) => c.id === this.buyCurrencySelected.value
      );
      const sellCurrency = this.walletRepo.list.find(
        (c) => c.id === this.sellCurrencySelected.value
      );
      if (!buyCurrency || !sellCurrency) return false;
      return (
        (buyCurrency.name === "USD" && sellCurrency.name === "USDT") ||
        (buyCurrency.name === "USDT" && sellCurrency.name === "USD")
      );
    },
    displayedBuyRate(): number {
      return this.isUsdUsdtPair ? this.sellRate : this.buyRate;
    },
    displayedSellRate(): number {
      return this.sellRate;
    },
  },
  methods: {
    formatRate(rate: number): string {
      return rate.toFixed(5);
    },
    emitPairChange() {
      const buyCurrency = this.walletRepo.list.find(
        (c) => c.id === this.buyCurrencySelected.value
      );
      const sellCurrency = this.walletRepo.list.find(
        (c) => c.id === this.sellCurrencySelected.value
      );

      if (buyCurrency && sellCurrency) {
        this.$emit("pair-changed", {
          currency_id_from: this.buyCurrencySelected.value,
          currency_id_to: this.sellCurrencySelected.value,
          currency_type_from: buyCurrency.type,
          currency_type_to: sellCurrency.type,
        });
      }
    },
  },
});
